import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar-empty",
  "use": "calendar-empty-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"calendar-empty\">\n    <path d=\"M8 8V2M16 8V2M24 8V2M32 8V2M38 16H2M6 38H34C36.2091 38 38 36.2091 38 34V10C38 7.79086 36.2091 6 34 6H6C3.79086 6 2 7.79086 2 10V34C2 36.2091 3.79086 38 6 38Z\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol